<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title16"></a><div class="title-toc">Table of Contents</div>
<div class="toc_entry"><span class="toc_entry_titlePage" href="#/e9781429968553_tp01" id="toctitle13" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<a class="toc_entry_chapter" href="#/e9781429968553_c01" id="toctitle1"><span><strong class="b">THE KOMSOMOL TRUTH</strong></span></a><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c02" id="toctitle2" title="Link target outside of Sample"><span><strong class="b">GLOOM-DEFLECTING MAILMAN WARRIOR GODS</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c03" id="toctitle3" title="Link target outside of Sample"><span><strong class="b">DOWN AND OUT ON HOPE STREET</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c04" id="toctitle4" title="Link target outside of Sample"><span><strong class="b">IMAGING THE OTHER</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c05" id="toctitle5" title="Link target outside of Sample"><span><strong class="b">I WANTED UNICORNS</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c06" id="toctitle6" title="Link target outside of Sample"><span><strong class="b">THE BENEFITS OF SELF-CASTRATION</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c07" id="toctitle7" title="Link target outside of Sample"><span><strong class="b">TAKE OFF YOUR PANTS AND DRINK WITH US</strong></span></span><br/>
<span class="toc_entry_chapter" href="#/e9781429968553_c08" id="toctitle8" title="Link target outside of Sample"><span><strong class="b">GROWING INTO THE UNIVERSAL</strong></span></span><br/>
<span class="toc_entry_backMatter" href="#/e9781429968553_bm01" id="toctitle9" title="Link target outside of Sample"><span><strong class="b">THREE RANDOM FACEBOOK CHATS WITH MEN I HAD ASSUMED WERE FANS</strong></span></span><br/>
<span class="toc_entry_backMatter" href="#/e9781429968553_bm02" id="toctitle10" title="Link target outside of Sample"><span><strong class="b">YOU MUST GO AND WIN</strong></span></span><br/>
<span class="toc_entry_acknowPage" href="#/e9781429968553_ack01" id="toctitle11" title="Link target outside of Sample"><span><strong class="b">ACKNOWLEDGMENTS</strong></span></span><br/>
<span class="toc_entry_aboutAuthorPage" href="#/e9781429968553_ata01" id="toctitle12" title="Link target outside of Sample"><span><strong class="b">ABOUT THE AUTHOR</strong></span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781429968553_cop01" id="toctitle14" title="Link target outside of Sample"><span>Copyright Page</span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781429968553_toc01.vue?4378d024